
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.52 16.228l-.773-.773-2.49 2.49-2.491-2.49-.773.773 2.49 2.49-2.49 2.492.773.773 2.49-2.491 2.491 2.49.774-.772-2.491-2.491 2.49-2.491zM7.87 9.442a1.546 1.546 0 100-3.092 1.546 1.546 0 000 3.092zm4.209 0a1.546 1.546 0 100-3.092 1.546 1.546 0 000 3.092z","fill":"#fff"}}),_c('path',{attrs:{"d":"M26.25 3.516H4.349c-.515 0-.859.343-.859.859v21.902c0 .516.344.86.86.86h21.9c.515 0 .859-.344.859-.86V4.375c0-.516-.344-.86-.86-.86zm-.858 1.718V10.3H5.207V5.234h20.185zm-3.436 13.485c0 3.693-3.006 6.7-6.7 6.7a6.708 6.708 0 01-6.699-6.7c0-3.694 3.006-6.7 6.7-6.7 3.693 0 6.7 3.006 6.7 6.7zm-16.749 6.7v-13.4h4.982a8.298 8.298 0 00-3.35 6.7 8.298 8.298 0 003.35 6.7H5.207zm15.117 0a8.297 8.297 0 003.35-6.7 8.297 8.297 0 00-3.35-6.7h5.068v13.4h-5.068z","fill":"#fff"}})])
          )
        }
      }
    